import {
  CameraFilled,
  CheckOutlined,
  FolderOpenOutlined,
  LineOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Col, Row, Image, Button } from "antd";

import fukudaBase from "../images/fukuda_front.png";
import fukudaLato from "../images/fukuda_lato.png";
import TestUI from "./TestUI";
import { PosturalExamination, PosturalTestDefinition } from "./interfaces";
import { photoNotTakenYet, TakenPhoto } from "./PosturalExamWrapper";
import { useEffect, useRef, useState } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";


const PosturalExamFukuda_TakePhotos = ({
  images,
  getWebcamPhoto,
  loadPhoto,
}: {
  images: TakenPhoto[];
  getWebcamPhoto: Function;
  loadPhoto: Function;
}) => {
  const ref1 = useRef<any>();
  const ref2 = useRef<any>();


  const AnimatedButton = () => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [key, setKey] = useState(0);

    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Row>
          <Col span={12}>
            <div style={{ textAlign: "center", marginTop: "20px", zoom: "0.5" }}>
              <CountdownCircleTimer
                key={key}
                isPlaying={isPlaying}
                duration={45}
                colors={['#9edcc4f3', '#d1863aad', '#a785a98f', '#a785a98f']}
                colorsTime={[30, 20, 10, 0]}
                onComplete={() => {
                  setIsPlaying(false);
                  setKey(prevKey => prevKey + 1); // Reset the timer
                }}
              >
                {({ remainingTime }) => (
                  <div style={{ fontSize: "50px", fontWeight: "bold", color: "#75b39bf3" }}>
                    {remainingTime}
                  </div>
                )}
              </CountdownCircleTimer>
            </div>
          </Col>
          <Col span={2}></Col>
          <Col span={10}>
            <Button
              style={{
                top: "25%",
                marginTop: "20px",
                color: "#555555f3",
                fontWeight: "bold",
                borderRadius: "25px",
              }}
              disabled={isPlaying}
              onClick={() => setIsPlaying(true)}
            >
              START COUNTDOWN
            </Button>
          </Col>
        </Row>
      </div>
    );
  };
  //For Responsive

  const [width, setWidth] = useState(0);
  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    //mount
    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    //unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {width > 640 && (
        <div className="centered" style={{ width: "64%" }}>

           
        
        
          <Row>
          
          
            <Col span={1} />
            <Col span={11}>
              <div>
                <Image
                  style={{
                    borderRadius: "25px",
                  }}
                  fallback={fukudaBase}
                  preview={
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                  }
                  src={(images.length >= 1 && images[0].url) || fukudaBase}
                />
              </div>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => getWebcamPhoto(0)}
              >
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref1.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref1}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(0, e.target.files[0]);
                  }}
                />
                <FolderOpenOutlined rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                      ? images[0].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 1 && images[0].url != photoNotTakenYet.url ? (
                  images[0].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={11}>
              <div>
                <Image
                  style={{
                    borderRadius: "25px",
                  }}
                  fallback={fukudaLato}
                  preview={
                    images.length >= 2 && images[1].url != photoNotTakenYet.url
                  }
                  src={(images.length >= 2 && images[1].url) || fukudaLato}
                />
              </div>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => getWebcamPhoto(1)}
              >
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref2.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref2}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(1, e.target.files[0]);
                  }}
                />
                <FolderOpenOutlined rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 2 && images[1].url != photoNotTakenYet.url
                      ? images[1].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 2 && images[1].url != photoNotTakenYet.url ? (
                  images[1].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={1} />
            <AnimatedButton />
           
          </Row>


        </div>
      )}
      {width <= 640 && (
        <div className="centrados" style={{ width: "64%" }}>
          <Row>
            <Col span={1} />
            <Col span={11}>
              <div>
                <Image
                  style={{
                    borderRadius: "25px",
                  }}
                  fallback={fukudaBase}
                  preview={
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                  }
                  src={(images.length >= 1 && images[0].url) || fukudaBase}
                />
              </div>

              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref1.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref1}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(0, e.target.files[0]);
                  }}
                />
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                      ? images[0].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 1 && images[0].url != photoNotTakenYet.url ? (
                  images[0].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={11}>
              <div>
                <Image
                  style={{
                    borderRadius: "25px",
                  }}
                  fallback={fukudaLato}
                  preview={
                    images.length >= 2 && images[1].url != photoNotTakenYet.url
                  }
                  src={(images.length >= 2 && images[1].url) || fukudaLato}
                />
              </div>

              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref2.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref2}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(1, e.target.files[0]);
                  }}
                />
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 2 && images[1].url != photoNotTakenYet.url
                      ? images[1].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 2 && images[1].url != photoNotTakenYet.url ? (
                  images[1].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={1} />
          </Row>
        </div>
      )}{" "}
    </>
  );
};

const PosturalExamFukudaRight = ({
  page,
  images,
  getWebcamPhoto,
  loadPhoto,
  testDefinitions,
  posturalExamination,
  setTestSelection,
  justCreated,
}: {
  page: number;
  images: TakenPhoto[];
  getWebcamPhoto: Function;
  loadPhoto: Function;
  testDefinitions: PosturalTestDefinition[];
  posturalExamination: PosturalExamination;
  setTestSelection: Function;
  justCreated: boolean;
}) => {
  if (testDefinitions && testDefinitions.length > 0)
    testDefinitions.sort((td1, td2) => td1.id - td2.id);

  useEffect(() => {
    if (
      justCreated &&
      (images.length < 1 || images[0].url == photoNotTakenYet.url)
    )
      loadPhoto(0, fukudaBase);

    if (
      justCreated &&
      (images.length < 2 || images[1].url == photoNotTakenYet.url)
    )
      loadPhoto(1, fukudaLato);
  }, []);

  return (
    <>
      {page == 0 && (
        <PosturalExamFukuda_TakePhotos
          images={images}
          loadPhoto={loadPhoto}
          getWebcamPhoto={getWebcamPhoto}
        />
      )}
      {page == 1 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 3 ? testDefinitions[3] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 3
                ? posturalExamination.testSelections[3]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
          <TestUI
            testDefinition={
              testDefinitions.length > 4 ? testDefinitions[4] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 4
                ? posturalExamination.testSelections[4]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
        </>
      )}
      {page == 2 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 1 ? testDefinitions[1] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 1
                ? posturalExamination.testSelections[1]
                : undefined
            }
            setTestSelection={setTestSelection}
          />

          <TestUI
            testDefinition={
              testDefinitions.length > 2 ? testDefinitions[2] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 2
                ? posturalExamination.testSelections[2]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
        </>
      )}
      {page == 3 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 0 ? testDefinitions[0] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 0
                ? posturalExamination.testSelections[0]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
        </>
      )}
    </>
  );
};

export default PosturalExamFukudaRight;
